<template>
  <header>
    <div
      class="flex justify-between h-[50px] items-center bg-black/80 px-4 py-2"
    >
      <div>
        <router-link
          v-for="route in routes"
          :key="route.name"
          class="p-1.5 rounded text-red-600 border-red-600 hover:bg-red-600 hover:text-white text-white text-lg"
          :to="route.path"
        >
          {{ route.name }}
        </router-link>
      </div>
      <div class="flex">
        <div class="text-white">{{ clubname }}</div>
        <router-link class="ml-3 link text-red-600" to="/profile"
          >Профіль</router-link
        >
        <div class="ml-3 text-white cursor-pointer" @click="logOut">Вийти</div>
      </div>
    </div>
  </header>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "AppHeader",
  data: function () {
    return {
      clubname: "",
      routes: [
        {
          name: "Клієнти",
          path: "/clients",
        },
        {
          name: "Карти та послуги",
          path: "/cards",
        },
        {
          name: "Групи",
          path: "/groups",
        },
        {
          name: "Розклад",
          path: "/schedule",
        },
        {
          name: "Приміщення",
          path: "/facilities",
        },
        {
          name: "Тренери",
          path: "/trainers",
        },
        {
          name: "Маркетинг",
          path: "/marketing",
        },
        // {
        //   name: "Аналітика",
        //   path: "/analytics",
        // },
        {
          name: "Візити",
          path: "/visits",
        },
        {
          name: "Каса",
          path: "/balance",
        },
      ],
    };
  },
  async mounted() {
    this.getClub();
  },
  methods: {
    ...mapActions(["logOutUser"]),
    getClub() {
      let club = this.$cookie.get("club_id");
      if (club === "1") {
        this.clubname = "Василенко, 9";
      } else {
        this.clubname = "Острозького, 55";
      }
    },
    logOut() {
      this.logOutUser();
    },
  },
};
</script>

<style scoped>
.link {
  text-decoration: none !important;
}
</style>
